import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';

import { useSaveCalculation } from '../composables/useSaveCalculation';

import { useCalculationsStore } from '../store/calculations';

export function useDeleteCalculationSegment() {
  const visible = ref(false);
  const isLoading = ref(false);

  const { saveCalculation } = useSaveCalculation();

  const calculationStore = useCalculationsStore();

  const toast = useToast();

  async function deleteCalculationSegment(calculationUuid: string, segmentId: number) {
    try {
      isLoading.value = true;

      const calculation = calculationStore.deleteCalculationSegment(calculationUuid, segmentId);

      if (!calculation) {
        throw Error('Nie znaleziono kalkulacji');
      }

      saveCalculation(calculation);
    } catch (error) {
      console.log(error);

      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas usuwania kalkulacji',
        life: 3000,
      });
    } finally {
      visible.value = false;
      isLoading.value = false;
    }
  }

  return {
    visible,
    isLoading,
    deleteCalculationSegment,
  };
}
